import { render } from "./ContentKarir.vue?vue&type=template&id=c6e534ae&scoped=true"
import script from "./ContentKarir.vue?vue&type=script&lang=js"
export * from "./ContentKarir.vue?vue&type=script&lang=js"

import "./ContentKarir.vue?vue&type=style&index=0&id=c6e534ae&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e534ae"]])

export default __exports__